let Cacoo = Cacoo || {};

Cacoo.util = {
  validateEmail: function(email) {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },

  isUrlString: function(s) {
    let re = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    return re.test(s);
  },

  getResourceWithArg: function(resource, args) {
    for (let i = 0; i < args.length; i++) {
      resource = resource.replace('{' + i + '}', args[i]);
    }

    return resource;
  },

  getUrlParameter: function(sParam) {
    let sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      aParameterKV,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      aParameterKV = sURLVariables[i].split('=');

      if (aParameterKV[0] === sParam) {
        return aParameterKV[1] === undefined ? true : decodeURIComponent(aParameterKV[1]);
      }
    }
  },

  checkEmailExists: function(email) {
    return new Promise((resolve, reject) => {
      Cacoo.ajax({
        url: window.Cacoo.settings.baseUrl + '/api/site/user/isEmailRegistered',
        method: "POST",
        data: {
          mailAddress: email
        },
        success: (data) => {
          resolve(data)
        },
        error: () => {
          reject();
        }
      });
    })

  }
};


Cacoo.ajax = function (param) {
  let success = param.success;
  let error = param.error;
  param.success = function (data, dataType) {
    if (success) {
      //var json = data ? $.secureEvalJSON(data) : '';
      //success(json, dataType);
      success(data, dataType);
    }
  };
  param.error = function (XMLHttpRequest, textStatus, errorThrown) {
    error(XMLHttpRequest, textStatus, errorThrown);
  };

  param.dataType = 'json';
  let existingBeforeSendFunciton = param.beforeSend;
  param.beforeSend = function (xhr) {
    if(existingBeforeSendFunciton){
      existingBeforeSendFunciton();
    }

    xhr.setRequestHeader('Accept-Language', window.Cacoo.settings.lang);
  };
  $.ajax(param);

  function showError(message) {
    Cacoo.notify(message, {background: "#ff9999"});
  }
};

module.exports.cacoo = Cacoo;
